import { Injectable } from "@angular/core";
import * as color from "../../config/colors";
import * as backgroundColor from "../../config/backgroundColor";
import * as toolbox from "../../config/toolbox";
import * as tooltip from "../../config/tootip";
import * as geo from "../../config/geo";
import * as visualMap from "../../config/visualMap";
import * as series from "../../config/series";
import * as textStyle from '../../config/textStyle';
import * as _ from "lodash";
import { CommonService } from "../../service/common.service";
import { displayType } from "./district-map-intreface";
import { ChartDarkModeService } from "../../service/chart-dark-mode.service";

@Injectable({
  providedIn: "root",
})
export class DistrictMapService {
  constructor(
    private commonService: CommonService,
    private darkModeService: ChartDarkModeService
  ) { }

  getDistrictMapDefaultOptions(displayType: displayType = "area") {
    let style = this.commonService.changeFontSize();
    let dimension = 2;
    let defaultOption = {
      backgroundColor: backgroundColor.backgroundColor,
      color: color.defaultColors,
      // toolbox: toolbox.getToolboxBasicMenu(),
      geo: geo.getCommonGeo(style, "myMap"),
      visualMap: visualMap.getVisualMapOfPiecewise(style, dimension),
      tooltip: tooltip.getTooltipOfAreaMap(),
      series: this.getSeriesByDisplayType(displayType),
      textStyle: textStyle.getTextStyle()
    };
    return defaultOption;
  }

  // 更改显示类型
  changeDisplayType(chartOption, displayType: displayType = "area") {
    chartOption.series = this.getSeriesByDisplayType(displayType);
  }

  // 通过显示类型获取series
  getSeriesByDisplayType(displayType: displayType) {
    let style = this.commonService.changeFontSize();
    switch (displayType) {
      case "area":
        return series.getMapSeries();
      case "point":
        return series.getDistrictScatterSeries(style);
      default:
        return series.getMapSeries();
    }
  }

  // 更改图数据
  changeChartData(
    chartOption,
    displayType: displayType,
    chartData:
      | {
        name: string;
        visualMap: { type: string; data: any };
        data: { name: string; value: any[] }[];
      }
      | { [key: string]: any[] },
    geoCoordMap: any
  ) {
    if (displayType === "area") {
      chartOption.series[0].data = chartData.data;
    } else if (displayType === "point") {
      chartOption.series[0].data = this.convertData(
        chartData.data,
        geoCoordMap
      );
    }
  }

  // 转换数据
  convertData = (data, geoCoordMap) => {
    var res = [];
    for (var i = 0; i < data.length; i++) {
      var geoCoord = geoCoordMap[data[i].name];
      if (geoCoord) {
        res.push({
          name: data[i].name,
          value: geoCoord.concat(data[i].value),
        });
      }
    }
    return res;
  };

  // 更改映射维度
  changeVisualmapDimension(chartOption, bcacDisplayType, dimension = 0) {
    if (bcacDisplayType === "point") {
      chartOption.visualMap.dimension = dimension + 2;
    } else if (bcacDisplayType === "area") {
      chartOption.visualMap.dimension = dimension;
    }
  }

  // 修改维度名称
  changeDimensionNames(
    chartOption,
    displayType: displayType,
    dimensionNames: { [key: string]: string }[]
  ) {
    // chartOption.series
    let names = [],
      units = [];
    for (const iterator of dimensionNames) {
      names.push(iterator.dimensionName);
      units.push(iterator.unit);
    }
    if (displayType == "area") {
      chartOption.series[0].dimensions = names;

      chartOption.tooltip = tooltip.getTooltipOfAreaMap(units);
    } else if (displayType == "point") {
      let pointName = ["lng", "lat"];
      pointName = pointName.concat(names);

      chartOption.series[0].dimensions = pointName;

      chartOption.tooltip = tooltip.getTooltipOfPointMap(units);
    }
  }

  // 更改visualmap位置
  changeVisualMapPosition(chartOption, position: "left" | "right") {
    switch (position) {
      case "left":
        chartOption.visualMap.left = 0;
        delete chartOption.visualMap.right;
        break;
      case "right":
        chartOption.visualMap.right = 0;
        delete chartOption.visualMap.left;
        break;
      default:
        chartOption.visualMap.left = 0;
        delete chartOption.visualMap.right;
        break;
    }
  }

  // 修改visualMap
  changeVisualMap(
    chartOption,
    visualmapPosition: "left" | "right",
    displayType: "area" | "point",
    visualMaps:
      | {
        type: "continuous";
        data: { min: number; max: number; color?: string[] };
      }
      | { type: "piecewise"; data: { [key: string]: any }[] },
    dimension: number = 0,
    darkMode: boolean | string = false
  ) {
    let style = this.commonService.changeFontSize();

    if (displayType === "point") {
      dimension += 2;
    }
    if (!_.isEmpty(visualMaps)) {
      if (visualMaps.type === "continuous") {
        chartOption.visualMap = visualMap.getVisualMapOfContinuous(
          style,
          dimension,
          visualMaps.data.min,
          visualMaps.data.max
        );
        if (
          visualMaps.data.hasOwnProperty("color") &&
          visualMaps.data.color.length > 0
        ) {
          chartOption.visualMap.inRange.color = visualMaps.data.color;
        }
      } else if (visualMaps.type === "piecewise") {
        if (
          visualMaps.hasOwnProperty("data") &&
          Array.isArray(visualMaps.data)
        ) {
          chartOption.visualMap = visualMap.getVisualMapOfPiecewise(
            style,
            dimension,
            visualMaps.data
          );
        } else {
          chartOption.visualMap = visualMap.getVisualMapOfPiecewise(
            style,
            dimension
          );
        }
      }
    } else {
      chartOption.visualMap = visualMap.getVisualMapOfPiecewise(
        style,
        dimension
      );
    }
    this.changeVisualMapPosition(chartOption, visualmapPosition);
    this.openDarkMode(chartOption, darkMode);
  }

  // 更改geoLabel显示状态
  changeGeoShowLabel(chartOption, show: boolean) {
    if (show) {
      chartOption.geo.label.show = show;
      chartOption.geo.emphasis.label.show = show;
    }
  }

  // 改变toolbox的显示状态
  // changeToolboxShow(chartOption, chartShowToolbox: boolean) {
  //   if (typeof chartShowToolbox === "boolean") {
  //     chartOption.toolbox.show = chartShowToolbox;
  //   }
  // }

  // 开启黑暗模式
  openDarkMode(chartOption, darkMode: boolean | string) {
    if (typeof darkMode === "string") {
      chartOption.backgroundColor = darkMode;
    } else if (darkMode) {
      this.darkModeService.setMapDarkMode(chartOption);
    }
  }
}
